<!-- Auction Halls Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <!-- Search Input -->
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input
          type="text"
          class="form-control form-control-solid w-250px ps-13"
          placeholder="Search auction halls..."
          [(ngModel)]="searchTerm"
          (keyup)="onSearchKeyup()"
        />
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-auction-hall-table-toolbar="base">
        <!-- Add Auction Hall Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddAuctionHallModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Auction Hall
        </button>
      </div>
    </div>
  </div>



  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Auction Halls Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-200px">Auction Hall Name</th>
            <th class="min-w-120px">Created Date</th>
            <th class="min-w-100px">Status</th>
            <th class="min-w-150px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="4" class="text-center py-5">
              <div class="d-flex align-items-center justify-content-center">
                <div class="spinner-border spinner-border-sm text-primary me-2"></div>
                <span class="text-muted">Loading auction halls...</span>
              </div>
            </td>
          </tr>

          <!-- Empty State -->
          <tr *ngIf="!isLoading && auctionHalls.length === 0">
            <td colspan="4" class="text-center py-5">
              <div class="text-center">
                <i class="ki-duotone ki-information-5 fs-1 text-primary mb-3">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                </i>
                <p class="text-muted fs-6 mb-0">No auction halls found</p>
              </div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let auctionHall of auctionHalls; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-5">
                  <div class="symbol-label bg-light-primary">
                    <i class="ki-duotone ki-home fs-2 text-primary">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </div>
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ auctionHall.name || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ auctionHall.created_at | date:'dd/MM/yyyy' }}
              </span>
            </td>
            <td>
              <span class="badge"
                    [ngClass]="auctionHall.active ? 'badge-light-success' : 'badge-light-danger'">
                {{ auctionHall.active ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Toggle Active/Inactive Button -->
                <button type="button"
                        class="btn btn-sm btn-icon"
                        [ngClass]="auctionHall.active ? 'btn-light-danger' : 'btn-light-success'"
                        (click)="toggleActiveStatus(auctionHall)"
                        [title]="auctionHall.active ? 'Deactivate Auction Hall' : 'Activate Auction Hall'">
                  <i class="ki-duotone fs-6"
                     [ngClass]="auctionHall.active ? 'ki-cross' : 'ki-check'">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Edit Button -->
                <button type="button"
                        class="btn btn-sm btn-icon btn-light-primary"
                        (click)="openEditAuctionHallModal(auctionHall)"
                        title="Edit Auction Hall">
                  <i class="ki-duotone ki-pencil fs-6">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Button -->
                <button type="button"
                        class="btn btn-sm btn-icon btn-light-danger"
                        (click)="deleteAuctionHall(auctionHall)"
                        title="Delete Auction Hall">
                  <i class="ki-duotone ki-trash fs-6">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && auctionHalls.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<!-- Auction Hall Add/Edit Modal -->
<app-add-edit-auction-hall
  (auctionHallAdded)="onAuctionHallAdded()"
  (auctionHallUpdated)="onAuctionHallUpdated()">
</app-add-edit-auction-hall>
